<div [ngStyle]="{ overflow: 'hidden', display: documentExist ? 'block' : 'none' }">
  <div fxLayout="column" fxLayoutGap="10px grid" class="documentCardList" fxFill>
    @for (document of documentsList; track document) {
      <abcCard
        fxFlex="100"
        id="{{ document.Id }}"
        [class]="'cardDocument'"
        displayText="{{ document.Designation }}"
      secondaryDisplayText="{{ document.Kind }} {{ ConvertHelper.toLocaleFormattedDateString(document.Date) }} {{
        getDocumentFileName(document)
      }}"
        [leftIsImg]="false"
        [leftIconPosition]="1"
        [leftIconSize]="2"
        leftIconPath="{{ tryGetDocumentType(document) }}"
        [buttons]="document.Buttons"
        >
      </abcCard>
    }
  </div>
</div>

<abcLoader [show]="showLoader"></abcLoader>

<div
  [ngStyle]="{
    display: !documentExist && !showLoader ? 'block' : 'none'
  }"
  >
  {{ res('DocumentsEditorCard-NoDocuments') }}
</div>

<div #abcWindowContainer id="abcWindowContainer"></div>

@if (isIconsVisible && isAllowed && !isReadOnly) {
  <div class="addDocButton">
    <button mat-fab class="fab-toggler" (click)="detailDocument()" [disabled]="!parentId">
      <i class="material-icons">add</i>
    </button>
  </div>
}
